class ToggleTabs extends HTMLElement {
  constructor() {
    super();
    this.tablinks = this.querySelectorAll('.tablink');
    this.tabcontents = this.querySelectorAll('.tabcontent');
    this.categoryPills = this.querySelectorAll('input[name="category-radio"]');
    
    this.handleClick = this.handleClick.bind(this); // Bind function
    this.handleRadioChange = this.handleRadioChange.bind(this);
  }
  
  connectedCallback() {
    this.setupEventListeners();

    // Open a corresponding tab with the same id of data-tab-selected of modal-opener-tabs button
    subscribe(PUB_SUB_EVENTS.switchTab, (tabSelected) => {
      this.toggleActiveTab(tabSelected);
      this.toggleActiveContent(tabSelected);
    });
  }

  setupEventListeners() {
    this.tablinks.forEach((button) => {
      button.addEventListener('click', this.handleClick);
    });

    this.categoryPills.forEach((radio) => {
      radio.addEventListener('change', this.handleRadioChange);
    });
  }

  handleClick(event) {
    const button = event.currentTarget;
    if (!button.classList.contains('js-tab--active')) {
      this.toggleActiveTab(button);
      this.toggleActiveContent(button);
    }
  }

  handleRadioChange(event) {
    const selectedValue = event.target.value;

    this.toggleActivePill(selectedValue);
    this.toggleRelatedPillContent(selectedValue);
  }
  
  toggleActiveTab(target) {
    this.tablinks.forEach(tab => {
      const isActive = tab === target; // Return a boolean
      tab.classList.toggle('js-tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  toggleActiveContent(target) {
    let clickedTab = target.dataset.tab;
  
    this.tabcontents.forEach(content => {
      const isActive = content.id === clickedTab;
      content.classList.toggle('js-tabcontent--active', isActive);
    });
  }

  toggleActivePill(selectedValue) {
    this.querySelectorAll('input[name="category-radio"]').forEach(radio => {
      if (radio.value === selectedValue) {        
        radio.setAttribute('checked', '');
      } else {
        radio.removeAttribute('checked');
      }
    });
  }

  toggleRelatedPillContent(selectedValue) {
    this.querySelectorAll('.tabpanel-related-content').forEach(content => {
      const isTarget = content.getAttribute('data-category') === selectedValue;
      
      content.classList.toggle('tabpanel-related-content--active', isTarget);
      content.setAttribute("aria-hidden", isTarget ? "false" : "true");
      content.setAttribute("tabindex", isTarget ? "1" : "0");
    });
  }
  
}

customElements.define('toggle-tabs', ToggleTabs);
